import React, { KeyboardEvent } from 'react';
import styled from 'styled-components';
import * as Yup from 'yup';

import FormErrorMessage from 'packages/kakapo-ui-kit/components/forms/errors/FormErrorMessage';
import { ISheetEditorEvents } from 'packages/kakapo-ui-settings-application/pages/bulk-employee-edit/types/sheet';

const BulkFieldElement = styled.input`
	display: block;
	padding: 20px 5px;
	width: 100% !important;
	text-align: left;
`;

export const createBulkFieldKeyDownHandler = (events: ISheetEditorEvents, value: string) => {
	return (event: KeyboardEvent<HTMLElement>) => {
		const { key } = event;
		if (key === 'Escape') {
			events.onRevert();
			return;
		}

		if (key === 'Enter' || key === 'Tab') {
			events.onCommit(value);
		}
	};
};

const BulkField = ({
	value,
	events,
	validationSchema,
}: {
	value: string;
	events: ISheetEditorEvents;
	validationSchema?: Yup.StringSchema;
}) => {
	const invalid = validationSchema ? !validationSchema.isValidSync(value) : false;

	return (
		<>
			<BulkFieldElement
				autoFocus
				value={value}
				onKeyDown={createBulkFieldKeyDownHandler(events, value)}
				onChange={(event) => events.onChange(event.currentTarget.value)}
			/>
			{invalid && <FormErrorMessage error={new Error('Field invalid.')} />}
		</>
	);
};

export default BulkField;
